/** Pin icon only — no "visaproofs" wordmark */
export const ICON_ONLY_SVG = '/images/logo/icononly.svg';

/** Full logo with "visaproofs" text */
export const MAIN_LOGO_SVG = '/images/logo/main-logo.svg';

/** Standard favicon kit (public root) */
export const FAVICON_ICO = '/favicon.ico';
export const FAVICON_16 = '/favicon-16x16.png';
export const FAVICON_32 = '/favicon-32x32.png';
export const APPLE_TOUCH_ICON = '/apple-touch-icon.png';
export const WEB_MANIFEST = '/site.webmanifest';
